<template>
  <footer id="footer">
    <router-link v-if="user" class="report" :to="{ name: 'report' }"
      >Report A Bug</router-link
    >
    <a class="mediatalo" href="http://360mediahouse.com" target="_blank">
      <img src="../assets/360mediahouse.png" />
    </a>
  </footer>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'TheFooter',
  computed: {
    ...mapState({
      user: state => state.user.user,
    }),
  },
};
</script>

<style lang="scss" scoped>
footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: auto;
  width: 100vw;
  justify-content: space-between;
  padding: $space-4 $space-6;
  border-top: 1px solid color(border);
  background: color(surface);
  .report {
    font-size: $text-sm;
    font-weight: $weight-medium;
    color: color(slate-500);
    transition: color $transition-fast;

    &:hover {
      color: color(primary-600);
      text-decoration: none;
    }
  }
  img {
    width: 132px;
    opacity: 0.75;
    transition: opacity $transition-fast;
  }
  .mediatalo {
    margin-left: auto;
    &:hover img {
      opacity: 1;
    }
  }
}
</style>
